export default "__VITE_ASSET__9rnCJgU2__"